export const breakpoints = {
	base: '0em', // mobile (default)
	sm: '30em', // 480px  → large phones
	md: '48em', // 768px  → tablets
	l: '50.9375em', // 815px  → small tablets
	lg: '62em', // 992px  → small laptops
	xl: '80em', // 1280px → desktops
	'2xl': '96em' // 1536px → large screens
} as const;
